import React, { useState } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import SelectDropdown from "../../atoms/SelectDropdown";
import Icon from "../../icons";

import "./tagStorySearch.m.css";
import { TOPICS_FILTER, TOPICS_FILTER_PARENT } from "../../../constants";
import { staticTexts } from "../../utils/Translate";

const filterChild = id => TOPICS_FILTER.filter(item => item["parent-external-id"] === id);
const findItem = id => TOPICS_FILTER.find(item => item["external-id"] === id);

const TagStorySearch = ({ className = "", publisherAttributes }) => {
  const defaultList = [
    {
      name: staticTexts(publisherAttributes.lang).section,
      "external-id": "1",
      "parent-external-id": null,
      slug: ""
    },
    {
      name: staticTexts(publisherAttributes.lang).district,
      "external-id": "2",
      "parent-external-id": null,
      slug: ""
    },
    {
      name: staticTexts(publisherAttributes.lang).upazila,
      "external-id": "3",
      "parent-external-id": null,
      slug: ""
    }
  ];
  const [selectParent, setSelectParent] = useState(null);
  const [selectChild, setSelectChild] = useState(null);
  const [selectSubChild, setSelectSubChild] = useState(null);
  const [childList, setChildList] = useState([]);
  const [subChildList, setSubChildList] = useState([]);
  const [selectedItemSlug, setValue4] = useState(null);

  const onChangeFunc1 = e => {
    setSelectParent(e.target.value);
    setSelectChild(null);
    setSelectSubChild(null);
    setChildList(filterChild(e.target.value));
    const item = findItem(e.target.value);
    setValue4(item.slug);
  };

  const onChangeFunc2 = e => {
    setSelectChild(e.target.value);
    setSelectSubChild(null);
    setSubChildList(filterChild(e.target.value));
    const item = findItem(e.target.value);
    setValue4(item.slug);
  };

  const onChangeFunc3 = e => {
    setSelectSubChild(e.target.value);
    const item = findItem(e.target.value);
    setValue4(item.slug);
  };

  return (
    <div styleName="base" className={className}>
      <Headline text={staticTexts(publisherAttributes.lang).localNews} headlineType={12} className="headline-title" />
      <SelectDropdown
        list={TOPICS_FILTER_PARENT}
        onChange={onChangeFunc1}
        className="dropdown-list"
        defaultItem={defaultList[0]}
        selected={selectParent}
      />
      <SelectDropdown
        list={childList}
        onChange={onChangeFunc2}
        className="dropdown-list"
        defaultItem={defaultList[1]}
        selected={selectChild}
      />
      <SelectDropdown
        list={subChildList}
        onChange={onChangeFunc3}
        className="dropdown-list"
        defaultItem={defaultList[2]}
        selected={selectSubChild}
      />
      <button
        styleName="tag-search-btn"
        onClick={() => (window.location.href = "/topic/" + selectedItemSlug)}
        disabled={!selectedItemSlug}
      >
        <span styleName="search-icon">
          <Icon type="search" className="search-icon" />
        </span>
        {staticTexts(publisherAttributes.lang).search}
      </button>
    </div>
  );
};

TagStorySearch.propTypes = {
  className: string,
  story: object,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(TagStorySearch);
